import { useTranslation } from "react-i18next";

import BaseProgressBar from "@/components_v2/ProgressBars/BaseProgressBar";
import AnalyticsCard from "@/features/certifications/analytics/components/AnalyticsCard";
import { toPercent } from "@/features/certifications/analytics/utils";
import { StatsCardProps } from "@/features/certifications/analytics/types";

import "../styles.css";

const STATUSES = [
  "notStarted",
  "inProgress",
  "awaitingReview",
  "certified",
] as const;

const ParticipantStatusCard = ({
  data,
  isLoading,
  isError,
}: StatsCardProps) => {
  const { t } = useTranslation();
  const prefix = "certification.admin.analytics.status";
  const active = data?.enrollments.active ?? 0;

  return (
    <AnalyticsCard
      title={t(`${prefix}.title`)}
      aside={
        data?.completionRate !== null && data?.completionRate !== undefined ? (
          <span className="analytics-muted body-s-regular">
            {t(`${prefix}.completionRate`, {
              percent: toPercent(data.completionRate),
            })}
          </span>
        ) : undefined
      }
      isLoading={isLoading}
      isError={isError}
    >
      {data && (
        <div className="flex flex-col gap-300">
          {STATUSES.map((status) => {
            const label = t(`${prefix}.states.${status}`);
            const count = data.participants[status];
            return (
              <BaseProgressBar
                key={status}
                value={count}
                total={Math.max(active, 1)}
                label={label}
                helpText={String(count)}
                className="analytics-bar"
                aria-label={label}
                aria-valuetext={String(count)}
              />
            );
          })}
        </div>
      )}
    </AnalyticsCard>
  );
};

export default ParticipantStatusCard;
